/* 产品页复用原数量区块，保留输入值、主题编辑器属性及商品表单关联。 */
if (!customElements.get('product-purchase-layout')) {
    customElements.define('product-purchase-layout', class extends HTMLElement {
        connectedCallback() {
            // 等待子区块解析完成；主题编辑器重新加载 section 时同样执行。
            this.layoutFrame = requestAnimationFrame(() => this.alignPurchaseControls());
        }

        disconnectedCallback() {
            cancelAnimationFrame(this.layoutFrame);
        }

        alignPurchaseControls() {
            const quantityBlock = this.querySelector('[data-product-quantity-block]');
            const quantityInput = quantityBlock?.querySelector('input[name="quantity"]');
            const form = quantityInput?.form;
            const buttons = form?.querySelector('.product-form__buttons');
            if (!buttons || !this.contains(form) || buttons.contains(quantityBlock)) return;

            const blockWrapper = quantityBlock.closest('.shopify-block') || quantityBlock;
            blockWrapper.classList.add('product-purchase-layout__quantity');
            buttons.prepend(blockWrapper);
            buttons.classList.add('product-purchase-layout__buttons');
        }
    });
}
